module.exports = __webpack_public_path__ + "static/media/task_assign_one.2c12e0be.png";